import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Button, DateTimeInput } from '@weezevent/nacre';

import css from '../emaillogs.module.css';

export const DateTimeFilterModal = ({ open, onClose, onSubmit, dateAfter, dateBefore }) => {
    const { t } = useTranslation();
    const [afterValue, setAfterValue] = React.useState(dateAfter);
    const [beforeValue, setBeforeValue] = React.useState(dateBefore);
    const [activeKey, setActiveKey] = React.useState('last-week');
    const currentDate = new Date();

    const presets = [
        { key: 'custom', label: t('sauron.emails.email-logs.date-filter.custom'), date_after: null, date_before: null },
        { key: 'today', label: t('sauron.emails.email-logs.date-filter.today'), date_after: currentDate.toJSON(), date_before: currentDate.toJSON() },
        {
            key: 'last-week',
            label: t('sauron.emails.email-logs.date-filter.last-week'),
            date_after: new Date(new Date().setDate(currentDate.getDate() - 7)).toJSON(),
            date_before: currentDate.toJSON()
        },
        {
            key: 'last-month',
            label: t('sauron.emails.email-logs.date-filter.last-month'),
            date_after: new Date(new Date().setMonth(currentDate.getMonth() - 1)).toJSON(),
            date_before: currentDate.toJSON()
        },
        {
            key: 'last-year',
            label: t('sauron.emails.email-logs.date-filter.last-year'),
            date_after: new Date(new Date().setFullYear(currentDate.getFullYear() - 1)).toJSON(),
            date_before: currentDate.toJSON()
        }
    ];

    return (
        <Modal
            className={css['modal-container card-subtitle']}
            size={'large'}
            open={open}
            allowExternalClosing={true}
            onClose={onClose}
            title={t('sauron.emails.email-logs.date-filter.title')}
            subtitle={t('sauron.emails.email-logs.date-filter.subtitle')}
            customFooter={
                <Button.Group>
                    <Button onClick={onClose} label={t('common.cta.cancel')} />
                    <Button
                        primary
                        inverted
                        disabled={!afterValue || !beforeValue}
                        onClick={() => onSubmit({ date_after: afterValue, date_before: beforeValue })}
                        label={t('common.cta.save')}
                    />
                </Button.Group>
            }
        >
            <div className={css['date-modal-content']}>
                {t('sauron.emails.email-logs.date-filter.time-range')}
                <div className={css['choose-range-buttons']}>
                    {presets.map(preset => {
                        return (
                            <Button
                                key={preset.key}
                                onClick={() => {
                                    setActiveKey(preset.key);
                                    setAfterValue(preset.date_after);
                                    setBeforeValue(preset.date_before);
                                }}
                                primary={preset.key === activeKey}
                                inverted={preset.key === activeKey}
                            >
                                {preset.label}
                            </Button>
                        );
                    })}
                </div>
                <DateTimeInput
                    dateLabel={t('sauron.emails.email-logs.date-filter.start-date')}
                    timeLabel={t('sauron.emails.email-logs.date-filter.time')}
                    onChange={newValue => setAfterValue(newValue)}
                    value={afterValue}
                />
                <DateTimeInput
                    dateLabel={t('sauron.emails.email-logs.date-filter.end-date')}
                    timeLabel={t('sauron.emails.email-logs.date-filter.time')}
                    onChange={newValue => setBeforeValue(newValue)}
                    value={beforeValue}
                />
            </div>
        </Modal>
    );
};
